import React from 'react';
import { IconSvgProps } from '@models/common';

const Plus: React.FC<IconSvgProps> = (props) => {
  const { size = 32, strokeWidth = 3, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='M5 12.5h14M12 5.5v14'
      />
    </svg>
  );
};

export default Plus;
